export type SinglePdfHeaderType = { name: string; column_value: string };

export const tableHeaders: SinglePdfHeaderType[] = [
  {
    name: "No",
    column_value: "no",
  },
  {
    name: "Description",
    column_value: "description",
  },
  {
    name: "HSN/SAC",
    column_value: "hsn_sac_code",
  },
  {
    name: "SKU",
    column_value: "sku_code",
  },
  {
    name: "Rate",
    column_value: "rate",
  },
  {
    name: "Qty",
    column_value: "quantity",
  },
  {
    name: "Amount",
    column_value: "amount",
  },
  {
    name: "Discount",
    column_value: "discount",
  },
  {
    name: "Taxable",
    column_value: "taxable_value",
  },
  {
    name: "GST %",
    column_value: "gst_percentage",
  },
  {
    name: "IGST",
    column_value: "igst_amount",
  },
  {
    name: "CGST",
    column_value: "cgst_amount",
  },
  {
    name: "SGST",
    column_value: "sgst_amount",
  },
  {
    name: "Total",
    column_value: "total_value",
  },
];

export const GST_SUMMARY_HEADERS: SinglePdfHeaderType[] = [
  {
    name: "GST Summary",
    column_value: "gst_percentage",
  },
  {
    name: "Amount",
    column_value: "total_taxable_amount",
  },
  {
    name: "IGST",
    column_value: "total_igst_amount",
  },
  {
    name: "CGST",
    column_value: "total_cgst_amount"
  },
  {
    name: "SGST",
    column_value: "total_sgst_amount"
  },
  {
    name: "Total",
    column_value: "total_amount",
  },
]

export const BATCH_SUMMARY_HEADERS: SinglePdfHeaderType[] = [
  {
    name: "No",
    column_value: "no",
  },
  {
    name: "Description",
    column_value: "description",
  },
  {
    name: "Batch ID",
    column_value: "batch_id"
  },
  {
    name: "HSN/SAC",
    column_value: "hsn_sac_code",
  },
  {
    name: "SKU",
    column_value: "sku_code",
  },
  {
    name: "Rate",
    column_value: "rate",
  },
  {
    name: "Qty",
    column_value: "quantity",
  },
  {
    name: "Amount",
    column_value: "amount",
  },
  {
    name: "Discount",
    column_value: "discount",
  },
  {
    name: "Taxable",
    column_value: "taxable_value",
  },
  {
    name: "GST %",
    column_value: "gst_percentage",
  },
  {
    name: "IGST",
    column_value: "igst_amount",
  },
  {
    name: "CGST",
    column_value: "cgst_amount",
  },
  {
    name: "SGST",
    column_value: "sgst_amount",
  },
  {
    name: "Total",
    column_value: "total_value",
  },
];